import React from 'react'
import { isClient } from '../../../helpers'
import { ChrComponent, ChrGlobal } from '../../../types'
import { withParsedContext } from '../../Magazines/withJSSContext'

interface Props {
  parsedFields: {
    footerModel: ChrComponent
  }

  parsedSitecoreContext: {
    'Discovery.Feature.FeIntegration.IntegrationData'?: ChrGlobal
  }
}

const FooterZone: React.FC<Props> = ({ parsedFields, parsedSitecoreContext }) => {
  const footerModel = parsedFields.footerModel
  const footerAnalyticsModel = parsedSitecoreContext['Discovery.Feature.FeIntegration.IntegrationData']

  if (isClient) {
    window.chrComponents = window.chrComponents || {}
    window.chrGlobal = footerAnalyticsModel || {}
    window.chrComponents.footer = window.chrComponents.footer || {}
    window.chrComponents.footer.data = footerModel.data
    window.chrComponents.footer.labels = footerModel.labels
  }

  return (
    <div className="chr-header-footer">
      <chr-footer data-namespace="footer"></chr-footer>
      <chr-modal-provider></chr-modal-provider>
    </div>
  )
}

export default withParsedContext(FooterZone as React.FC)
